import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment, endpoints } from '@environment';
import {
  Reminder,
  CreateReminderRequest,
  UpdateReminderRequest,
} from '@core/models';

@Injectable({ providedIn: 'root' })
export class ReminderService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/${endpoints.v1.reminders}`;

  get(): Observable<Reminder> {
    return this.http.get<Reminder>(this.baseUrl);
  }

  create(reminder: CreateReminderRequest): Observable<Reminder> {
    return this.http.post<Reminder>(this.baseUrl, reminder);
  }

  update(reminder: UpdateReminderRequest): Observable<Reminder> {
    return this.http.put<Reminder>(this.baseUrl, reminder);
  }

  delete(): Observable<void> {
    return this.http.delete<void>(this.baseUrl);
  }
}
